import { Button, FormGroup, InputGroup, Modal } from "@vesatogo/grass-core"
import { useState } from "react"

export type AddSFCodeModalProps = {
  isOpen: boolean
  onClose: () => void
  onSubmit: (code: string) => void
}

export const AddSFCodeModal = ({
  isOpen,
  onClose,
  onSubmit,
}: AddSFCodeModalProps) => {
  const [code, setCode] = useState("")

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Add SF Code"
      bodyClassName="!max-w-sm"
      primaryActionButtonProps={{
        text: "Submit",
        onClick: () => {
          onSubmit(code)
          onClose()
        },
      }}
      secondaryActionButtonProps={{
        text: "Cancel",
        onClick: onClose,
      }}
    >
      <div className="flex flex-col gap-6 p-2">
        <InputGroup
          inputProps={{
            placeholder: "Enter",
            value: code,
            onChange: e => setCode(e.target.value),
          }}
        />
      </div>
    </Modal>
  )
}
